//import $ from "jquery";


(async () => {
    const bind = async() => {

        const els =
            $(".dpl-fm-contentmap");

        if(els.length>0) {
            await import(/* webpackChunkName: "fm-contentmap" */ './scripts/Client');
        }
    };

    await bind();
    document.addEventListener('ui-repaint', () => {
        bind();
    });


    if( window.acf ) {
        window.acf.addAction(
            'render_block_preview',
            (el, ev) => {
                if(ev.name==='acf/fm-contentmap') {
                    bind();
                }
            });
    }
})();